<template>
  <v-container>
    <SaiMonthlyCriteria
      :saiMonthlySummaryBaseCrudKey="saiMonthlySummaryBaseCrudKey"
      :saiMonthlyTransactionBaseCrudKey="saiMonthlyTransactionBaseCrudKey"
      @loadSaiMonthlySummaryList="loadSummaryAndTransactionList"
    />
    <SaiMonthlySummaryList/>
    <SaiMonthlyTransactionList />
  </v-container>
</template>

<script>

import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import SaiMonthlySummaryList from './SaiMonthlySummary/SaiMonthlySummaryList.vue';
import SaiMonthlyTransactionList from './SaiMonthlyTransaction/SaiMonthlyTransactionList.vue';
import SaiMonthlyCriteria from './SaiMonthlyCriteria.vue';
import { headersByType } from './SaiMonthlyTransaction/transaction.headers';
import {
  getFYList, getIdFromList, getMaxFY, toFiscalYear,
} from '../../../util/shared/tmc-global';

export default {
  name: 'SaiList',
  components: {
    SaiMonthlyCriteria,
    SaiMonthlySummaryList,
    SaiMonthlyTransactionList,
  },
  data: () => ({
    saiMonthlySummaryBaseCrudKey: 'saiMonthlySummary',
    saiMonthlyTransactionBaseCrudKey: 'saiMonthlyTransaction',
    passedData: false,
  }),
  created() {
    this.initCriteria();
    this.loadBankList();
    this.initializeFiscalYears();
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
    ]),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return getFYList(registerdYears);
      },
    }),
    saiMonthlyTransactionCriteriaState: {
      get() {
        return this.criteria(this.saiMonthlyTransactionBaseCrudKey);
      },
      set(value) {
        this.setCriteria([this.saiMonthlyTransactionBaseCrudKey, value]);
      },
    },
    saiMonthlySummaryCriteriaState: {
      get() {
        return this.criteria(this.saiMonthlySummaryBaseCrudKey);
      },
      set(value) {
        this.setCriteria([this.saiMonthlySummaryBaseCrudKey, value]);
      },
    },
    ...mapGetters('user', [
      'getSettings',
    ]),
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItems',
    ]),
    ...mapMutations('glDaily/saiMonthlyTransaction', [
      'setHeaders',
    ]),
    ...mapActions('glDaily/saiMonthlySummaryTransaction', [
      'loadSaiMonthlySummary',
    ]),
    ...mapActions('glDaily/saiMonthlyTransaction', [
      'loadSaiMonthlyTransaction',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions({
      loadDepartments: 'OD/loadDepartments',
    }),
    initCriteria() {
      this.saiMonthlySummaryCriteriaState = {};
      this.saiMonthlyTransactionCriteriaState = {};
      this.saiMonthlySummaryCriteriaState.fiscalYear = toFiscalYear(new Date(this.todaysDate));
      this.saiMonthlyTransactionCriteriaState.section = 'BANKS';
    },
    loadTransactionList() {
      const criteria = this.saiMonthlyTransactionCriteriaState;
      const itemId = getIdFromList(this, this.saiMonthlySummaryBaseCrudKey);
      // permanently updating summary ID to criteria
      criteria.saiMonthlySummary = itemId;
      const section = criteria.section || 'BANKS';
      this.settingHeaders(section);
      this.loadSaiMonthlyTransaction({
        criteria,
        baseCrudKey: this.saiMonthlyTransactionBaseCrudKey,
      });
    },
    async loadSummaryAndTransactionList() {
      const criteria = { ...this.saiMonthlySummaryCriteriaState };
      criteria.month = (criteria.monthyear || {}).month;
      criteria.year = (criteria.monthyear || {}).year;
      delete criteria.monthyear;
      await this.loadSaiMonthlySummary({
        criteria,
        baseCrudKey: this.saiMonthlySummaryBaseCrudKey,
      });
      const items = this.items(this.saiMonthlySummaryBaseCrudKey) || [];
      if (items.length > 0) {
        this.loadTransactionList();
      } else {
        this.setItems([this.saiMonthlyTransactionBaseCrudKey, []]);
      }
    },
    settingHeaders(section) {
      this.setHeaders(headersByType[section]);
    },
    loadBankList() {
      const bankList = this.loadBanks({
        criteria: {},
        baseCrudKey: 'sharedBank',
      });
      return bankList;
    },
    loadFundsList() {
      this.loadFunds({
        criteria: {
          /*
            passing criteriaState FY instead of todaysDate to get FY
            if maxFY < sharedFunds (current FY/max FY)
          */
          fiscalYear: this.saiMonthlySummaryCriteriaState.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedFund',
      });
    },
    loadDepartmentList() {
      this.loadDepartments(this.saiMonthlySummaryCriteriaState);
    },
    loadLists() {
      this.loadFundsList();
      this.loadDepartmentList();
    },
    async initializeFiscalYears() {
      if ((this.fiscalYearRange || []).length > 0) {
        const maxFY = getMaxFY(this.fiscalYearRange || []);
        this.saiMonthlySummaryCriteriaState.fiscalYear = maxFY;
        this.loadLists();
      }
    },
  },
};
</script>
